export default __webpack_public_path__ + "static/media/Logo.f9f0ebff.png";